import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import propTypes from 'prop-types';
import {formatAsset, formatFiat} from "../../Utilities/utilities";

const StyledMinus = styled.span`
  font-size: 17px;
  position: absolute;
  transform: translateX(-1.3rem);
`

const CurrencyFormatter = ({type = 'ASSET', quantity = 0, code, symbol, onlyFormat=false}) => {
  const [formattedQuantity, setQuantity] = useState('0');

  useEffect(() => {
    let formattedValue;
    if (type === 'FIAT') {
      formattedValue = formatFiat(quantity)
    } else {
      let assetQuantity = formatAsset(quantity);
      formattedValue = assetQuantity.match(/\.[0-9]{2}/g) ? assetQuantity : assetQuantity.match(/\.[0-9]/g) ? `${assetQuantity}0` : `${assetQuantity}.00000000`
    }

    setQuantity(formattedValue);
  }, [quantity, type])

  if (onlyFormat) {
    return formattedQuantity;
  } else {
    return (
      <>
        {Math.sign(quantity) === -1 && <StyledMinus>&#8722;</StyledMinus>}
        {symbol}{formattedQuantity}{code && <>&nbsp; {code}</>}
      </>
    )
  }
}

CurrencyFormatter.propTypes = {
  type: propTypes.string,
  quantity: propTypes.number,
  symbol: propTypes.symbol,
  onlyFormat: propTypes.bool,
  code: propTypes.string,
}

export default CurrencyFormatter;